/**
 * Calculates the processing duration in milliseconds for an operation.
 * @param startTime - The timestamp when the operation started, or null if not started
 * @returns The duration in milliseconds, or undefined if startTime is null
 */
export function calculateProcessingDurationMs(
  startTime: number | null,
): number | undefined {
  return startTime ? Date.now() - startTime : undefined
}
